"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlightDepartureEditor = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const dateTime_1 = require("../../../../utils/dateTime");
const Date_1 = require("../../../Form/Field/Date");
const FlightDepartureEditor = (props) => {
    const { field, allowedDays } = props;
    const { value, onValue, error, modifiers } = field;
    const fieldProps = {
        withTime: true,
        autoComplete: 'off',
        name: 'departure',
        label: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/Edit:Departure', defaultMessage: 'Departure' })),
        value,
        setValue: onValue,
        error,
        restrictions: {
            disablePastDays: true,
            pastYearsCount: dateTime_1.bookingPastYearsCount,
            nextYearsCount: dateTime_1.bookingNextYearsCount,
            allowedDays,
        },
        modificators: modifiers,
    };
    return (react_1.default.createElement(Date_1.FormFieldDate, { ...fieldProps }));
};
exports.FlightDepartureEditor = FlightDepartureEditor;
//# sourceMappingURL=FlightDepartureEditor.js.map